// Where each kind of account lands: the screen the login form has always sent
// it to. Kept here so that signing in and coming back already signed in lead
// to the same place.
const HOME = {
    superadmin: '/superadmin/dashboard',
    hospitaladmin: '/hospitaladmin/dashboard',
    lab: '/lab/tests',
    pharmacy: '/pharmacy/prescriptions',
    optician: '/optician/orders',
    medicalseller: '/medicalseller/dashboard',
    companyseller: '/companyseller/dashboard',
    doctor: '/doctor/dashboard',
    secretary: '/secretary/appointments'
};

// Null for a role with no screens of its own, which is asked to sign in.
export const homePathFor = (role) => HOME[role] || null;

export default homePathFor;
